import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

export default class FestivalMap extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return(
      <div>
        <div className="festivalHome-bannerWrapper">

          <Link to="/girls-festival/tickets"><img className="desktop" src="/images/festival/home/gf_homepage_banner_desktop_post.jpg" /></Link>

          <Link to="/girls-festival/tickets"><img className="mobile" src="/images/festival/home/gf_homepage_banner_mobile_post.jpg" /></Link>
        </div>


        <div className="content-wrapper">
          <div className="headerTagWrapper">
            <div className="page-heading map-pageHeader">Girls' Festival Map</div>


          </div>
          <div className="festivalMap-wrapper">
            <img src="/images/festival/map3.jpg" />
          </div>
        </div>
      </div>

    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/FestivalMap.jsx